import { NgModule } from '@angular/core';

// #region all modules
import { AvatarListModule } from '@lxlib/seed/avatar-list';
import { CountDownModule } from '@lxlib/seed/count-down';
import { DatePickerModule } from '@lxlib/seed/date-picker';
import { DownFileModule } from '@lxlib/seed/down-file';
import { EllipsisModule } from '@lxlib/seed/ellipsis';
import { ErrorCollectModule } from '@lxlib/seed/error-collect';
import { ExceptionModule } from '@lxlib/seed/exception';
import { FooterToolbarModule } from '@lxlib/seed/footer-toolbar';
import { FullContentModule } from '@lxlib/seed/full-content';
import { GlobalFooterModule } from '@lxlib/seed/global-footer';
import { ImageModule } from '@lxlib/seed/image';
import { LoadingModule } from '@lxlib/seed/loading';
import { LodopModule } from '@lxlib/seed/lodop';
import { NoticeIconModule } from '@lxlib/seed/notice-icon';
import { NumberToChineseModule } from '@lxlib/seed/number-to-chinese';
import { PageHeaderModule } from '@lxlib/seed/page-header';
import { QRModule } from '@lxlib/seed/qr';
import { QuickMenuModule } from '@lxlib/seed/quick-menu';
import { ResultModule } from '@lxlib/seed/result';
import { ReuseTabModule } from '@lxlib/seed/reuse-tab';
import { SEModule } from '@lxlib/seed/se';
import { SGModule } from '@lxlib/seed/sg';
import { SidebarNavModule } from '@lxlib/seed/sidebar-nav';
import { STModule } from '@lxlib/seed/st';
import { SVModule } from '@lxlib/seed/sv';
import { TagSelectModule } from '@lxlib/seed/tag-select';
import { XlsxModule } from '@lxlib/seed/xlsx';
import { ZipModule } from '@lxlib/seed/zip';

const MODULES = [
  ErrorCollectModule,
  FooterToolbarModule,
  SidebarNavModule,
  DownFileModule,
  ImageModule,
  AvatarListModule,
  EllipsisModule,
  GlobalFooterModule,
  ExceptionModule,
  NoticeIconModule,
  PageHeaderModule,
  ResultModule,
  TagSelectModule,
  CountDownModule,
  STModule,
  ReuseTabModule,
  FullContentModule,
  XlsxModule,
  ZipModule,
  NumberToChineseModule,
  LodopModule,
  QuickMenuModule,
  QRModule,
  SVModule,
  SEModule,
  SGModule,
  DatePickerModule,
  LoadingModule,
];

@NgModule({ exports: MODULES })
export class LxlibSeedModule {}
